import {Component, EventEmitter, HostBinding, Input, Output} from '@angular/core';
import {GetRegion2Css, GetRegion2Name} from "../../defines/desktop.const";
import {SimpleDialect} from "../../models/dialect.model";

@Component({
  selector: 'app-link-popup-item-dialect',
  templateUrl: './link-popup-item-dialect.component.html',
  styleUrls: ['./link-popup-item.component.scss'],
})
export class LinkPopupItemDialectComponent {
  @HostBinding('style.display') styleBlock = 'block';
  @HostBinding('class') class = 'tooltip-item';
  @Input() dialect?: SimpleDialect;
  @Input() btnClose: boolean = false; // 닫기 버튼 표시 여부
  @Output() close = new EventEmitter<string | null>();

  protected readonly GetRegion2Name = GetRegion2Name;
  protected readonly GetRegion2Css = GetRegion2Css;

  protected onGotoDetail($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(this.dialect?.id);
  }

  protected onClose($event: MouseEvent): void {
    $event.stopPropagation();
    $event.preventDefault();
    this.close.emit(null);
  }
}
